import { ArgumentOutOfRangeException } from "../../shared/index.js";
export const elementAt = (source, index) => {
    if (index < 0) {
        throw new ArgumentOutOfRangeException("index");
    }
    let i = 0;
    for (const item of source) {
        if (index === i++) {
            return item;
        }
    }
    throw new ArgumentOutOfRangeException("index");
};
